'use client';

import { useParams } from 'next/navigation';
import { Container, Grid } from '@mantine/core';
import { SquareCard } from './SquareCard/SquareCard';
import styles from './SquareCardList.module.scss';
import PresentationOfSection from '../Atoms/PresentationOfSection/PresentationOfSection';

export const ClassicSquareCardList = ({ slice }: { slice: any }) => {
  const { lang } = useParams();

  console.log(slice)
  const { title, services } = slice;
  console.log('Services:', services);

  if (!services || services.length === 0) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', fontStyle: 'italic' }}>
        Aucun service disponible pour le moment.
      </div>
    );
  }

  return (
    <Container size="xl" className={styles.gridWrap}>
      <PresentationOfSection title={title} description={slice.description} />

      <Grid gutter={{ base: 'md', md: 'lg' }}>
        {services.map((service: any, index: number) => {
          const computedTitle =
            typeof service.title === 'object' ? service.title?.[lang as string] : service.title;

          // Ensure SquareCard gets the right shape:
          // { image, title, description, link, tag?, buttonLabel? }
          const data = {
            ...service,
            title: computedTitle,
          };

          return (
            <Grid.Col key={`${computedTitle}-${index}`} span={{ base: 12, md: 4, sm: 6 }} data-aos='fade-up' data-aos-delay={`${index * 300}`}>
              <SquareCard data={data} />
            </Grid.Col>
          );
        })}
      </Grid>
    </Container>
  );
};
